// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file search/search_inventory.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { TaxProfile } from "../medical_master/common_pb.js";
import { ItemType } from "../inventory/common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.SearchInventoryRequest
 */
export class SearchInventoryRequest extends Message<SearchInventoryRequest> {
  /**
   * The search query string
   *
   * @generated from field: string query = 1;
   */
  query = "";

  /**
   * The maximum number of results to return
   *
   * @generated from field: int32 limit = 2;
   */
  limit = 0;

  /**
   * If true, only return items that are currently available in stock
   *
   * @generated from field: bool only_available = 3;
   */
  onlyAvailable = false;

  /**
   * The ID of the stock point to search within
   *
   * @generated from field: string stock_point_id = 4;
   */
  stockPointId = "";

  constructor(data?: PartialMessage<SearchInventoryRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.SearchInventoryRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "query", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "only_available", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "stock_point_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SearchInventoryRequest {
    return new SearchInventoryRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SearchInventoryRequest {
    return new SearchInventoryRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SearchInventoryRequest {
    return new SearchInventoryRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SearchInventoryRequest | PlainMessage<SearchInventoryRequest> | undefined, b: SearchInventoryRequest | PlainMessage<SearchInventoryRequest> | undefined): boolean {
    return proto3.util.equals(SearchInventoryRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.SearchInventoryResponse
 */
export class SearchInventoryResponse extends Message<SearchInventoryResponse> {
  /**
   * List of inventory items matching the search query
   *
   * @generated from field: repeated com.neulink.pharmacy.SearchItem items = 1;
   */
  items: SearchItem[] = [];

  constructor(data?: PartialMessage<SearchInventoryResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.SearchInventoryResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: SearchItem, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SearchInventoryResponse {
    return new SearchInventoryResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SearchInventoryResponse {
    return new SearchInventoryResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SearchInventoryResponse {
    return new SearchInventoryResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SearchInventoryResponse | PlainMessage<SearchInventoryResponse> | undefined, b: SearchInventoryResponse | PlainMessage<SearchInventoryResponse> | undefined): boolean {
    return proto3.util.equals(SearchInventoryResponse, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.SearchItem
 */
export class SearchItem extends Message<SearchItem> {
  /**
   * The trade name of the inventory item
   *
   * @generated from field: string trade_name = 1;
   */
  tradeName = "";

  /**
   * The barcode of the inventory item
   *
   * @generated from field: string barcode = 2;
   */
  barcode = "";

  /**
   * The unit of measurement for the inventory item
   *
   * @generated from field: int32 unit = 3;
   */
  unit = 0;

  /**
   * The type of unit (e.g., "mg", "ml")
   *
   * @generated from field: string unit_type = 4;
   */
  unitType = "";

  /**
   * Unique identifier for the inventory item
   *
   * @generated from field: string id = 5;
   */
  id = "";

  /**
   * VAT percentage applicable to the item
   *
   * @generated from field: com.neulink.pharmacy.TaxProfile tax_profile = 6;
   */
  taxProfile?: TaxProfile;

  /**
   * Indicates if the item is active
   *
   * @generated from field: bool is_active = 7;
   */
  isActive = false;

  /**
   * Type of the inventory item (e.g., "drug", "device")
   *
   * @generated from field: com.neulink.pharmacy.ItemType type = 8;
   */
  type = ItemType.UNSPECIFIED;

  /**
   * Manufacturer of the inventory item
   *
   * @generated from field: string manufacturer = 9;
   */
  manufacturer = "";

  /**
   * Owner of the inventory item
   *
   * @generated from field: string owner = 10;
   */
  owner = "";

  /**
   * Scientific name of the inventory item
   *
   * @generated from field: string scientific_name = 11;
   */
  scientificName = "";

  /**
   * Category of the inventory item
   *
   * @generated from field: string category = 12;
   */
  category = "";

  /**
   * Sub-category of the inventory item
   *
   * @generated from field: string sub_category = 13;
   */
  subCategory = "";

  /**
   * Ranking score for search relevance
   *
   * @generated from field: float ranking_score = 14;
   */
  rankingScore = 0;

  /**
   * Indicates if this item is a suggestion based on search query
   *
   * @generated from field: bool is_suggestion = 15;
   */
  isSuggestion = false;

  /**
   * Available stock quantity for the item
   *
   * @generated from field: float available_stock = 16;
   */
  availableStock = 0;

  /**
   * Number of active batches for the item
   *
   * @generated from field: int32 active_batch_count = 17;
   */
  activeBatchCount = 0;

  /**
   * Average price of the item across batches
   *
   * @generated from field: float average_price = 18;
   */
  averagePrice = 0;

  constructor(data?: PartialMessage<SearchItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.SearchItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "trade_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "barcode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "unit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "unit_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "tax_profile", kind: "message", T: TaxProfile },
    { no: 7, name: "is_active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "type", kind: "enum", T: proto3.getEnumType(ItemType) },
    { no: 9, name: "manufacturer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "owner", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "scientific_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "sub_category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "ranking_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 15, name: "is_suggestion", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 16, name: "available_stock", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 17, name: "active_batch_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 18, name: "average_price", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SearchItem {
    return new SearchItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SearchItem {
    return new SearchItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SearchItem {
    return new SearchItem().fromJsonString(jsonString, options);
  }

  static equals(a: SearchItem | PlainMessage<SearchItem> | undefined, b: SearchItem | PlainMessage<SearchItem> | undefined): boolean {
    return proto3.util.equals(SearchItem, a, b);
  }
}

